export default "__VITE_ASSET__D31vXMId__"